import { strl_sanitize_html } from '~/js/helpers.js';

function strl_hit_title(hit) {
	if (!hit) {
		return '';
	}
	if (hit.post_title) {
		return String(hit.post_title);
	}
	if (hit.title) {
		return String(hit.title);
	}
	return '';
}

function strl_hit_faq_answer(hit, components) {
	if (!hit) {
		return '';
	}
	if (hit._snippetResult && hit._snippetResult['faq-answer'] && hit._snippetResult['faq-answer'].value) {
		return components.Snippet({ attribute: 'faq-answer', hit });
	}
	if (hit['faq-answer']) {
		return hit['faq-answer'];
	}
	if (hit._snippetResult && hit._snippetResult.post_content && hit._snippetResult.post_content.value) {
		return components.Snippet({ attribute: 'post_content', hit });
	}
	if (hit.post_content) {
		return hit.post_content;
	}
	return '';
}

function strl_render_faq_answer(answer, html) {
	if (!answer) {
		return '';
	}

	const answerClasses =
		'wysiwyg px-10 pt-0 pb-6 text-base leading-normal font-medium text-black';

	if (typeof answer === 'string') {
		const safeAnswer = strl_sanitize_html(answer);
		if (!safeAnswer) {
			return '';
		}
		return html`<div class="${answerClasses}" dangerouslySetInnerHTML=${{ __html: safeAnswer }}></div>`;
	}

	return html`<div class="${answerClasses}">${answer}</div>`;
}

export function faqCard(hit, html, components) {
	const answer = strl_hit_faq_answer(hit, components);

	return html`
		<details
			class="search-faq-card group open:bg-white/50 overflow-clip rounded-lg bg-white shadow-[-24px_24px_75px_-12px_rgba(18,18,23,0.12)] text-black"
		>
			<summary
				class="flex cursor-pointer list-none items-center justify-between gap-8 py-6 pr-6 pl-10 marker:content-none [&::-webkit-details-marker]:hidden"
			>
				<h3 class="h3 mb-0 text-left">
					${components.Highlight({ attribute: 'post_title', hit })}
				</h3>
				<i
					class="fa-solid fa-plus shrink-0 text-xl text-primary group-open:hidden!"
					aria-hidden="true"
				></i>
				<i
					class="fa-solid fa-minus hidden! group-open:inline! shrink-0 text-xl text-primary"
					aria-hidden="true"
				></i>
			</summary>
			${strl_render_faq_answer(answer, html)}
		</details>
	`;
}
